import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
type TrustRowProps = {
  className?: string;
  accessLabel?: string;
};
export function TrustRow({
  className = '',
  accessLabel = 'Instant Access'
}: TrustRowProps) {
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-softgray sm:text-sm ${className}`} data-id="element-240" data-mp="2hnplebs79yos">
      <li className="flex items-center gap-1.5" data-id="element-241" data-mp="1ozabu4ru88ku">
        <LockIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-242" data-mp="1p1wfvufis5yb" />
        Secure Payment
      </li>
      <li className="flex items-center gap-1.5" data-id="element-243" data-mp="1k2timw5s740w">
        <ZapIcon className="h-3.5 w-3.5 text-urgent" aria-hidden="true" data-id="element-244" data-mp="1yy9hrfl7xq45" />
        {accessLabel}
      </li>
      <li className="flex items-center gap-1.5" data-id="element-245" data-mp="1txv85t3yy840">
        <ShieldCheckIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-246" data-mp="1u19cv803utem" />
        7-Day Guarantee
      </li>
    </ul>;
}